<script setup lang="ts">
import RulerIcon from '@/components/icons/RulerIcon.vue';
import MessageHeartSquareIcon from '@/components/icons/MessageHeartSquareIcon.vue';
import LockKeyholeCircleIcon from '@/components/icons/LockKeyholeCircleIcon.vue';
import LockIcon from '@/components/icons/LockIcon.vue';

const menuItems = [
	{
		title: 'Terms of Service',
		url: ROUTE.TERMS.NAME,
		icon: RulerIcon,
	},
	{
		title: 'Community Guidelines',
		url: ROUTE.COMMUNITY_GUIDELINES.NAME,
		icon: MessageHeartSquareIcon,
	},
	{
		title: 'Privacy Policy',
		url: ROUTE.PRIVACY_POLICY.NAME,
		icon: LockKeyholeCircleIcon,
	},
	{
		title: 'Cookie Policy',
		url: ROUTE.COOKIE_POLICY.NAME,
		icon: LockIcon,
	},
];
</script>
<template>
  <div class="terms-menu-section">
    <a
      v-for="menu in menuItems"
      :key="menu.title"
      :href="menu.url"
      target="_blank"
      class="link"
    >
      <component
        :is="menu.icon"
        class="icon"
      />
      <h2 class="link-title text-xl text-semibold">{{ menu.title }}</h2>
    </a>
  </div>
</template>
<style scoped lang="scss">
.terms-menu-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: spacings-get(6) spacings-get(4);

    @include media-query-max(mobile) {
        grid-template-columns: 1fr;
    }

    .link {
        display: flex;
        align-items: center;
        padding: spacings-get(6);
        gap: spacings-get(6);
        text-align: start;
        box-shadow:
        0px 2px 4px -2px rgba(16, 24, 40, 0.06),
        0px 4px 8px -2px rgba(16, 24, 40, 0.1);
        @include border-radius-lg;

        .icon {
          display: flex;
          padding: spacings-get(3);
          background-color: colors-get(primary, 100);
          border-color: colors-get(primary, 50);
          border-width: spacings-get(2);
          border-style: solid;
          box-sizing: content-box;
          @include border-radius-rounded;
        }

        .link-title {
        color: colors-get(gray, 900);
        }
    }
}
</style>
